<template>
  <v-autocomplete
    v-bind="$attrs"
    :value="value"
    :items="items"
    :search-input.sync="search"
    :loading="loading"
    item-value="_id"
    item-text="text"
    @click="firstClick"
    v-on="$listeners"
  >
    <template slot="item" slot-scope="data">
      <v-list-tile-content>
        <v-list-tile-title>{{data.item.name}}</v-list-tile-title>
        <v-list-tile-sub-title v-if="data.item[itemSubName]">
          {{data.item[itemSubName]}}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>

<script>
import debouncePromise from 'debounce-promise';
import { searchQuery } from '../../lib/searchRegex';

export default {
  props: {
    service: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Object, Array],
      default: null,
    },
    limit: {
      type: Number,
      default: 25,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    itemSubName: {
      type: String,
      default: 'subname',
    },
  },
  data() {
    return {
      items: [],
      search: '',
      total: 0,
      loading: false,
      loadItemsDebounced: debouncePromise(this.loadItems, 500),
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.limit);
    },
    key() {
      return `${this.service}-${this.search}`;
    },
    valIds() {
      if (!this.value) return [];
      return Array.isArray(this.value)
        ? this.value.map(val => this.getValId(val))
        : [this.getValId(this.value)];
    },
    selectedItems() {
      return this.$store.getters[`${this.service}/find`]({
        query: {
          _id: { $in: this.valIds },
        },
      }).data;
    },
  },
  mounted() {
    setTimeout(async () => {
      if (!this.valIds.length) return;
      if (this.selectedItems.length === this.valIds.length) {
        this.items = this.selectedItems;
        this.total = this.selectedItems.length;
        this.loading = false;
        return;
      }
      const res = await this.$store.dispatch(`${this.service}/find`, {
        query: {
          _id: { $in: this.valIds },
          $limit: this.valIds.length,
        },
      });
      this.items = res.data;
      this.total = res.total;
      this.loading = false;
    }, 500);
  },
  watch: {
    key(to, from) {
      if ((!this.valIds.length || from !== `${this.service}-null`) && to !== from) {
        this.loading = true;
        this.loadItemsDebounced();
      }
    },
  },
  methods: {
    getValId(val) {
      if (typeof val === 'string') return val;
      return val._id;
    },
    firstClick() {
      if (!this.items.length) {
        this.loading = true;
        this.loadItemsDebounced();
      }
    },
    // eslint-disable-next-line func-names
    async loadItems() {
      this.loading = true;
      const res = await this.$cacheFind.find(`${this.service}-select`, this.service, this.key, {
        ...this.filter,
        ...searchQuery(this.search, this.service),
        _id: { $nin: this.selectedItems.map(item => item._id) },
        $limit: this.limit,
        $skip: (this.page - 1) * this.limit,
        $client: { paginate: { default: 100 } },
      });
      this.items = [
        ...this.selectedItems,
        ...res.data,
      ];
      this.total = res.total;
      this.loading = false;
    },
  },
};

</script>
